module.exports = __webpack_public_path__ + "img/thumb_34.426ee2a5.jpg";